import React from 'react';
import { Link } from 'react-router-dom';
import { LinkedinIcon, MailIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import { profile } from '../data/site';
const roles = ['Chief Legal Officer', 'General Counsel', 'Corporate Secretary', 'Board Advisor'];
export function Footer() {
  return <footer className="relative overflow-hidden bg-navy-900 text-slate-300" data-id="element-16" data-mp="36oxyl2tk7kyw">
      <div className="pattern-lattice-dark absolute inset-0 opacity-40" aria-hidden="true" data-id="element-17" data-mp="3uf0obca04euc" />
      <div className="relative mx-auto max-w-7xl px-6 py-16 lg:px-10" data-id="element-18" data-mp="3ud7iu0b4k0nx">
        <div className="grid gap-12 md:grid-cols-3" data-id="element-19" data-mp="387fpncvpdfs">
          <div data-id="element-20" data-mp="3levih6kghoia">
            <p className="font-display text-2xl font-light text-white" data-id="element-21" data-mp="3ldamrdmenziu">{profile.name}</p>
            <ul className="mt-5 space-y-1.5" data-id="element-22" data-mp="3qcnkwuiq8t0q">
              {roles.map(role => <li key={role} className="text-sm text-slate-400" data-id="element-23" data-mp="29zgnu9fpz8qc">
                  {role}
                </li>)}
            </ul>
          </div>

          <nav aria-label="Footer" className="md:justify-self-center" data-id="element-24" data-mp="2ew6zmkkhri5y">
            <p className="eyebrow text-gold" data-id="element-25" data-mp="3labr7utqu4pu">Navigate</p>
            <ul className="mt-5 space-y-2.5" data-id="element-26" data-mp="3gapbneqg0cdv">
              {[{
              label: 'Executive Profile',
              to: '/#about'
            }, {
              label: 'Career Highlights',
              to: '/#experience'
            }, {
              label: 'Insights',
              to: '/insights'
            }, {
              label: 'Contact',
              to: '/contact'
            }].map(item => <li key={item.label} data-id="element-27" data-mp="81pfpjtqwz9w">
                  <Link to={item.to} className="text-sm text-slate-400 transition-colors duration-300 hover:text-gold" data-id="element-28" data-mp="80nrednpyga8">
                    {item.label}
                  </Link>
                </li>)}
            </ul>
          </nav>

          <div className="md:justify-self-end" data-id="element-29" data-mp="cw36ta1dkk8r">
            <p className="eyebrow text-gold" data-id="element-30" data-mp="qujilfe3h0xr">Contact</p>
            <ul className="mt-5 space-y-3 text-sm text-slate-400" data-id="element-31" data-mp="mrwr5flc5i13">
              <li className="flex items-center gap-2.5" data-id="element-32" data-mp="mtra4od1r02j">
                <MapPinIcon className="h-4 w-4 text-gold/70" aria-hidden="true" data-id="element-33" data-mp="tvw6kdlnj9ee" />
                {profile.location}
              </li>
              <li data-id="element-34" data-mp="yupnyh427kju">
                <a href={`mailto:${profile.email}`} className="flex items-center gap-2.5 transition-colors hover:text-gold" data-id="element-35" data-mp="yrv0shtnvlmq">
                  <MailIcon className="h-4 w-4 text-gold/70" aria-hidden="true" data-id="element-36" data-mp="18lbulltst0qe" />
                  {profile.email}
                </a>
              </li>
              <li data-id="element-37" data-mp="1hk5xtv1mwpcx">
                <a href={`tel:${profile.phoneHref}`} className="flex items-center gap-2.5 transition-colors hover:text-gold" data-id="element-38" data-mp="1hjnvcgodpewk">
                  <PhoneIcon className="h-4 w-4 text-gold/70" aria-hidden="true" data-id="element-39" data-mp="1rjep2g547pvl" />
                  {profile.phone}
                </a>
              </li>
              <li data-id="element-40" data-mp="3od841810vwjv">
                <a href={profile.linkedin} target="_blank" rel="noreferrer" className="flex items-center gap-2.5 transition-colors hover:text-gold" data-id="element-41" data-mp="3ta8avl5p53c1">
                  <LinkedinIcon className="h-4 w-4 text-gold/70" aria-hidden="true" data-id="element-42" data-mp="25ncae2y0u44k" />
                  LinkedIn
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="hairline-prism mt-14 h-px w-full opacity-70" aria-hidden="true" data-id="element-43" data-mp="1woi9i0dnqrl7" />

        <div className="mt-6 flex flex-col gap-2 text-xs text-slate-500 sm:flex-row sm:items-center sm:justify-between" data-id="element-44" data-mp="2te9cko00ln2m">
          <p data-id="element-45" data-mp="2pdpglnr6gpi2">© {new Date().getFullYear()} Jessica L. Cumbee. All rights reserved.</p>
          <p data-id="element-46" data-mp="2kci5beptt86n">Dallas, Texas · Available for board and advisory engagements</p>
        </div>
      </div>
    </footer>;
}